import { useContext, useEffect, useState } from 'react'
import { useSceneStore } from '../../a.scenes/GameScene/store'
import { useScenesStore } from '../../b.providers/ScenesProvider/store'
import { SEL_BATTLE_STATE } from '../../c.managers/LevelManager/selectors'
import { BATTLE_STATES, COMMANDERS } from '../../c.managers/LevelManager/store.d'
import { SEL_LEVEL_SUMMARY, SEL_TREASURES } from '../../c.managers/TerrainManager/selectors'
import BaseWindow from './components/BaseWindow/BaseWindow'
import Overlay from './components/Overlay/Overlay'
import { NavContext, NavContextType, useNav } from './ScreensNav'

const LevelResults = ({ ctx }: { ctx: NavContextType }) => {
  const { dismiss, nav } = ctx
  const [localResult, setLocalResult] = useState<Record<string, number>>()
  const battleState = useSceneStore(SEL_BATTLE_STATE)
  const { candyWon, candyLost, diff } = useSceneStore(SEL_LEVEL_SUMMARY)
  const levelId = useScenesStore(s => s.user.currentLevelId)
  // const candySummary = useScenesStore(s => s.user.candySummary)

  useEffect(() => {
    // has global results and not locally
    if (!isNaN(candyWon) && !localResult) {
      setLocalResult({
        candyWon,
        candyLost,
        diff,
      })
      if (diff > 0) {
        useScenesStore.getState().updateCandyStock(diff)
      }
    }
  }, [candyWon, candyLost, diff, localResult])

  return (
    <>
      <BaseWindow show>
        <div className={`body-container`}>
          <div className="header-container">
            <span>Riot end</span>
          </div>
          <div className="body-content">
            <div className="body-row no-bottom-line">
              <span style={{ fontSize: '4.5vh' }}>Candy summary</span>
            </div>
            <div className="body-row">
              <div className="body-row-left">won</div>
              <div className="body-row-right">{(localResult ?? {}).candyWon}</div>
            </div>
            <div className="body-row">
              <div className="body-row-left">lost</div>
              <div className="body-row-right">{(localResult ?? {}).candyLost}</div>
            </div>
            <div className="body-row">
              <div className="body-row-left">=</div>
              <div className={`body-row-right ${(localResult ?? {}).diff <= 0 ? 'error' : 'success'}`}>
                {(localResult ?? {}).diff < 0 ? '-' : (localResult ?? {}).diff > 0 ? '+' : ''}
                {Math.abs((localResult ?? {}).diff)}
              </div>
            </div>
            {/* <div className="body-row">
              <div className="body-row-left">total</div>
              <div className="body-row-right">{candySummary}</div>
            </div> */}
            <a
              className="body-row no-bottom-line"
              onClick={() => {
                if ((localResult ?? {}).diff > 0) {
                  if (levelId !== '') {
                    nav('/new_item')
                  } else {
                    nav('/end')
                  }
                } else {
                  dismiss()
                }
              }}
            >
              <div className="theme-button button-orange-big">
                {(localResult ?? {}).diff > 0 ? 'NEXT' : 'TRY AGAIN'}
              </div>
            </a>
          </div>
        </div>
      </BaseWindow>
    </>
  )
}

export default LevelResults
